import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/firestore'

import router from '../router';

const user = {
    state: {
        authError: null,

        userCredential: null, // Firebase Auth Object
        userProfile: {}, // User

        userList: [],
        user: null
    },
    mutations: {
        AUTH_ERROR(state, payload) {
            state.authError = payload
        },
        USER_CREDENTIAL(state, payload) {
            state.userCredential = payload
        },
        USER_PROFILE(state, payload) {
            state.userProfile = payload
        },
        USER_LIST(state, payload) {
            state.userList = payload
        },
        USER(state, payload) {
            state.user = payload
        }
    },
    actions: {
        autoSignIn({commit}, userCredential) {
            commit('USER_CREDENTIAL', userCredential);
        },
        signIn({commit}, {email, password}) {
            firebase.auth().signInWithEmailAndPassword(email, password)
                .then(userCredential => {
                    commit('USER_CREDENTIAL', userCredential);
                    commit('AUTH_ERROR', null)

                    // Redirect to root view
                    router.push('/');
                })
                .catch(err => {
                    commit('USER_CREDENTIAL', null);
                    commit('AUTH_ERROR', err)
                });
        },
        resetPassword({commit}, email) {
            firebase.auth().sendPasswordResetEmail(email)
                .then(() => {
                    commit('USER_CREDENTIAL', null);
                    router.push('/signin');
                });
        },
        signOut({commit}) {
            firebase.auth().signOut()
                .then(() => {
                    commit('USER_CREDENTIAL', null)
                    commit('USER_PROFILE', null)

                    router.push('/signin')
                });
        },
        loadUserProfile({commit}, email) {
            firebase.firestore().collection('users').doc(email).get()
                .then(userProfileDoc => {
                    commit('USER_PROFILE', userProfileDoc.data());
                })
                .catch(() => {
                    commit('USER_PROFILE', null)
                })
        },
        getUsers({commit}) {
            // Fetch all users
            firebase.firestore().collection('users').get()
                .then(snapshot => {
                    let users = []
                    snapshot.forEach(doc => {
                        let user = doc.data()
                        user.id = doc.id
                        users.push(user)
                    })
                    commit('USER_LIST', users)
                })
                .catch(() => {
                    commit('USER_LIST', [])
                })
        },
        getUserById({commit}, userId) {
            firebase.firestore().collection('users').where('user_id', '==', userId).get()
                .then(snapshot => {
                    snapshot.forEach(doc => {
                        firebase.firestore().collection('users').doc(doc.id).get()
                            .then(userProfileDoc => {
                                commit('USER', userProfileDoc.data())
                            })
                    })
                })
                .catch(() => {
                    commit('USER', null)
                })
        },
        /* eslint-disable no-unused-vars */
        applyUser({commit}, user) {
            //console.log(`Apply user: ${JSON.stringify(user)}`)

            // Get user by email address
            let userRef = firebase.firestore().collection('users').doc(user.email);
            userRef.get().then(userDoc => {
                // Create user only if it does not exist
                if (!userDoc.exists) {
                    firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
                        .then(authDoc => {
                            // Add reference to Firebase Auth user
                            user.user_id = authDoc.user.uid
                            // Delete plain password
                            delete user.password
                            // Create user in collection
                            userRef.set(user)
                            // Route to list view
                            router.push({name: 'Users'})
                        })
                        .catch((err) => {
                            console.warn(`Apply user (${user.email}) failed: ${err.code}`)
                        })
                } else {
                    // Update user in collection
                    userRef.update(user)
                    // Route to list view
                    router.push({name: 'Users'})
                }
            })
        },
        deleteUser({state, commit}, userId) {
            console.log(`Delete user: ${userId}`)
            // Remove user by doc-id
            firebase.firestore().collection('users').where('user_id', '==', userId).get().then(snapshot => {
                snapshot.forEach(userDoc => {
                    firebase.firestore().collection('users').doc(userDoc.id).delete().then(() => {
                        // TODO: how to remove Firebase Auth User?

                        // Loop through userProfiles and filter for all others than deleted one
                        let newUsers = state.userList.filter(userProfile => {
                            return userProfile.user_id != userId
                        })
                        commit('USER_LIST', newUsers)
                    })
                })
            })
        }
    },
    getters: {
        isAuthenticated(state) {
            return state.userCredential !== null && state.userCredential !== undefined;
        },
        authError(state) {
            return state.authError
        },
        userProfile(state) {
            return state.userProfile
        },
        userList(state) {
            return state.userList
        }
    }
}

export default user
